@use './variables' as *;

:host {
  display: $checkbox-group-host-display;
}

.checkbox-group {
  display: $checkbox-group-display;
  padding-top: $checkbox-group-padding-top;
  padding-right: $checkbox-group-padding-right;
  padding-bottom: $checkbox-group-padding-bottom;
  padding-left: $checkbox-group-padding-left;
  margin-top: $checkbox-group-margin-top;
  margin-right: $checkbox-group-margin-right;
  margin-bottom: $checkbox-group-margin-bottom;
  margin-left: $checkbox-group-margin-left;
  &.error {
    color: $checkbox-group-error-color
  }
  &.success {
    color: $checkbox-group-success-color
  }
}

.status-text {
  display: block;
  color: inherited;
  margin-top: $checkbox-group-status-text-margin-top;
  margin-right: $checkbox-group-status-text-margin-right;
  margin-bottom: $checkbox-group-status-text-margin-bottom;
  margin-left: $checkbox-group-status-text-margin-left;
  
}
